// eslint-disable-next-line jira/filename-case
import React from 'react';
import Skeleton from '@atlaskit/avatar/skeleton';
// eslint-disable-next-line jira/import/file-extension-required
import { componentWithFG } from '@jira/platform__utils-feature-gates-gate-component';
import {
	useIssueTypeAvatarId,
	useIssueTypeAvatarUrl,
	useIssueTypeName,
} from './useIssueTypeName.tsx';
import type { IssueTypeAvatarSizes } from './makeAvatarUrlFromId.tsx';
import { IssueTypeAvatar, IssueTypeAvatarOld } from './IssueTypeAvatarOld.tsx';

type IssueTypeId = string;

type Props = {
	issueTypeId: IssueTypeId;
	size?: IssueTypeAvatarSizes;
};

const IssueTypeIconOld = ({ issueTypeId, size = 'xsmall' }: Props): React.JSX.Element => {
	const avatarId = useIssueTypeAvatarId({ issueTypeId });
	const issueTypeName = useIssueTypeName({ issueTypeId });

	if (avatarId === undefined) {
		return <Skeleton appearance="square" size={size} />;
	}

	return <IssueTypeAvatarOld avatarId={avatarId} size={size} name={issueTypeName} />;
};

const IssueTypeIconNew = ({ issueTypeId, size = 'xsmall' }: Props): React.JSX.Element => {
	const avatarUrl = useIssueTypeAvatarUrl({ issueTypeId });
	const issueTypeName = useIssueTypeName({ issueTypeId });

	if (avatarUrl === undefined) {
		return <Skeleton appearance="square" size={size} />;
	}

	return <IssueTypeAvatar avatarUrl={avatarUrl} size={size} name={issueTypeName} />;
};

export const IssueTypeIcon: React.FC<Props> = componentWithFG(
	'jpd_new-issue-types-avatars',
	IssueTypeIconNew,
	IssueTypeIconOld,
);
